const initialState = {
  group: '',
  permissions: [],
};

export default initialState;
